import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import type { Listing } from "../../../../../@types/listings/listing";

type ConfirmExitEditingDialogProps = {
  open: boolean;
  listing: Listing;
  onClose: () => void;
  onCloseContinue: () => void;
};

export function ConfirmExitEditingDialog({
  open,
  onClose,
  onCloseContinue
}: ConfirmExitEditingDialogProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Dialog open={open} onClose={onCloseContinue}>
      <DialogTitle>{translate("listingsPage.exitEditing")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translate("listingsPage.exitEditingDescription")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {translate("listingsPage.exit")}
        </Button>
        <Button onClick={onCloseContinue}>{translate("listingsPage.continueEditing")}</Button>
      </DialogActions>
    </Dialog>
  );
}
